
export { IconComponent } from "/app/libs/ui/components/icons/index.tsx"